<div class="clindx-form-table">
  <div class="search-cover">
    <mat-form-field class="search-field"  >
      <mat-label>Search</mat-label>
      <input matInput [disabled]="editOpen" (keyup)="applyFilter($event)" #input>
    </mat-form-field>
  </div>
  <div class="table-cover table-responsive">
    <form [formGroup]="config?.formGroup" autocomplete="off">
      <ng-container [formArrayName]="config?.formArrayName">
        <table #table mat-table [dataSource]="matDataSource" class="mat-elevation-z8">
          <caption></caption>
          @for (column of config?.columnList; track column) {
            <ng-container matColumnDef="{{column.columnName}}">
              <th id="tableheader" mat-header-cell *matHeaderCellDef>{{column.displayValue}}</th>
              <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                <span class="mobile-label">{{column.displayValue}}:</span>
                @if (column.columnName !== 'action') {
                  <mat-form-field style="width: 70px;"
                    [appearance]="config?.formGroup.get(config?.formArrayName).value[i].isEditable? 'none' : 'legacy'">
                    <input #inputValue matInput type="text" [formControlName]="column.columnName"
                      [readonly]="config?.formGroup.get(config?.formArrayName).value[i].isEditable">
                      @if (config?.formGroup.get(config?.formArrayName).at(i).get(config?.noDuplicates?.key).hasError('hasDuplicates')) {
                        <mat-error>
                          Parameter Code must be unique
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (column.columnName === 'action') {
                    @if (!config?.formGroup.get(config?.formArrayName).value[i].isEditable) {
                      <button mat-icon-button class="save-button" matTooltip="Save Changes"
                        [disabled]="config?.formGroup.invalid" (click)="save(config.formGroup,i)"
                        color="primary">
                        <mat-icon>check_circle</mat-icon>
                      </button>
                    }
                    @if (!config?.formGroup.get(config?.formArrayName).value[i].isEditable) {
                      <button mat-icon-button class="cancel-button" matTooltip="Cancel Changes" color="warn"
                        [disabled]="config?.formGroup.invalid" (click)="cancel(config.formGroup,i)"
                        >
                        <mat-icon>cancel</mat-icon>
                      </button>
                    }
                    @if (config?.formGroup.get(config?.formArrayName).value[i].isEditable) {
                      <button mat-icon-button class="save-button"
                        matTooltip="Edit"
                        color="primary" (click)="edit(config.formGroup,i)">
                        <mat-icon>edit</mat-icon>
                      </button>
                    }
                    @if (config?.formGroup.get(config?.formArrayName).value[i].isEditable) {
                      <button (click)="deleteRow(config.formGroup,i)" mat-icon-button class="delete-button"
                        matTooltip="Delete"
                        color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  }
                </td>
              </ng-container>
            }
            <ng-container matColumnDef="noData">
              <mat-footer-cell *matFooterCellDef colspan="6" class="norecord">
                @if (input.value) {
                  <span>No data matching the search "{{input.value}}"</span>
                }
              </mat-footer-cell>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']"
              [ngClass]="{'hide':!(matDataSource!=null && matDataSource?.data.length==0 || matDataSource?.filteredData.length==0)}">
            </tr>
          </table>
        </ng-container>
      </form>
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [pageIndex]="pageIndex"
        (page)="setPaginationObject()" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
